// extracted by mini-css-extract-plugin
export default {"root":"ReadList_root__bk393","item":"ReadList_item__rYwbV","stuName":"ReadList_stuName__LTq9o","stuId":"ReadList_stuId__8ocFe"};